import { IonIcon } from "@ionic/react";

import styles from "@components/typography/Typography.module.css";
import { IconList, IconName } from "@utils/iconUtils";

type Props = {
  icon: IconName;
};

const SecondaryButtonIcon = ({ icon }: Props) => (
  <IonIcon className={`${styles.secondaryButtonIcon} ${icon === "spinner" ? styles.spin : ""}`} src={IconList[icon]} />
);

export default SecondaryButtonIcon;
